import React, { lazy } from 'react';
import { Clock4Icon, HeartPulseIcon, ActivityIcon } from 'lucide-react';
export function ProofStrip() {
  return <section className="py-8 bg-white" data-id="element-282">
      <div className="container mx-auto px-4" data-id="element-283">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-284">
          <div className="flex items-center" data-id="element-285">
            <HeartPulseIcon className="text-[#6B9C37] mr-3 flex-shrink-0" size={24} data-id="element-286" />
            <span data-id="element-287">Noticeable relief in minutes</span>
          </div>
          <div className="flex items-center" data-id="element-288">
            <ActivityIcon className="text-[#6B9C37] mr-3 flex-shrink-0" size={24} data-id="element-289" />
            <span data-id="element-290">Stays on through bends</span>
          </div>
          <div className="flex items-center" data-id="element-291">
            <Clock4Icon className="text-[#6B9C37] mr-3 flex-shrink-0" size={24} data-id="element-292" />
            <span data-id="element-293">Up to 6–8 hours of comfort</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-294">
          <div className="bg-[#EFF5EA] p-4 rounded-lg" data-id="element-295">
            <div className="flex flex-col md:flex-row items-start" data-id="element-296">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-4 w-full md:w-auto" data-id="element-297">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sSxMjuZQMHUEzv6r4BA53H/Untitled_%283000_x_2000_px%29_%282%29.png" alt="Margaret gardening with MyoQuell patch" className="w-full md:w-48 h-auto object-cover rounded-lg" loading="lazy" data-id="element-298" />
              </div>
              <div data-id="element-299">
                <div className="text-amber-400 mb-1" data-id="element-300">★★★★★</div>
                <p className="font-medium" data-id="element-301">
                  "I can finally garden without thinking about my knees. These
                  patches stay put even when I'm up and down all day."
                </p>
                <p className="text-sm mt-2" data-id="element-302">— Margaret S., 58</p>
              </div>
            </div>
          </div>
          <div className="bg-[#EFF5EA] p-4 rounded-lg" data-id="element-303">
            <div className="flex flex-col md:flex-row items-start" data-id="element-304">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-4 w-full md:w-auto" data-id="element-305">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qP8ujFWvfEngJ2YEPJTBmT/Untitled_%283000_x_2000_px%29_%283%29.png" alt="Linda in medical scrubs with stethoscope" className="w-full md:w-48 h-auto object-cover rounded-lg" loading="lazy" data-id="element-306" />
              </div>
              <div data-id="element-307">
                <div className="text-amber-400 mr-2" data-id="element-308">★★★★☆</div>
                <p className="font-medium" data-id="element-309">
                  "Unlike other patches I've tried, these actually stick through
                  my whole shift. The gentle warmth is so soothing."
                </p>
                <p className="text-sm mt-2" data-id="element-310">— Linda K., 49</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}